export function IniciaisDoAluno({ nome, tamanho = 'sm' }: { nome: string; tamanho?: 'sm' | 'lg' }) {
  const iniciais = nome
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((parte) => parte[0])
    .join('')
    .toUpperCase()

  return (
    <div
      className={`shrink-0 rounded-xl bg-[#1a3a5c] text-white font-bold flex items-center justify-center ${
        tamanho === 'lg' ? 'w-11 h-11 text-base sm:w-16 sm:h-16 sm:text-xl' : 'w-12 h-12'
      }`}
    >
      {iniciais}
    </div>
  )
}
